import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=4920fb20&scoped=true&"
import script from "./PermissionDenied.vue?vue&type=script&lang=js&"
export * from "./PermissionDenied.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=4920fb20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920fb20",
  null
  
)

export default component.exports